import React, { Component } from 'react';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import styles from './NewForm.scss';
import Button from '../../components/Button/Button';
import { noop, stopEvent } from '../../utils/util';

export default class NewForm extends Component {
  static defaultProps = {
    onSubmit: noop,
    onCancelBtnClick: noop,
    clearInput: false,
    placeholder: '请输入内容...',
  };

  componentDidUpdate() {
    const { clearInput, focus } = this.props;
    if (clearInput) {
      this.input.value = '';
    }
    if (focus) {
      this.input.focus();
    }
  }

  onCancelBtnClick = (e) => {
    this.props.onCancelBtnClick(e);
  };

  onSubmit = (e) => {
    const inputVal = this.input.value;
    this.props.onSubmit(e, inputVal);
    stopEvent(e);
  };

  render() {
    const { placeholder, className } = this.props;
    return (
      <form onSubmit={this.onSubmit} className={classNames(styles['form'], className)}>
        <input
          placeholder={placeholder}
          type='text'
          name='name'
          className={styles['input']}
          ref={(input) => {
            this.input = input;
          }}
        />
        <Button
          className={styles['btn-confirm']}
          type={'primary'}
          htmlType={'submit'}
        >
          {i18n.get('global.commit')}
        </Button>
        <Button
          className={styles['btn-cancel']}
          onClick={this.onCancelBtnClick}
        >
          {i18n.get('global.cancel')}
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/NewForm.js